/**
 * LAS LLAVES QUE PROPONE ARES (LLAVES-PROPUESTAS-T1 vista, y la parte (c) de PANEL-ATAJOS-LLAVE-T1).
 *
 * DE DONDE SALE. Josse, 11-oct 15:2x: "no se podria que tu dejes borradores listos para yo solo aprobar las claves? que al
 * oprimir aprobar sea cuando se envien a la API". A (nexo-api 478) guarda la propuesta SIN secreto; aqui Josse la ve en
 * su idioma y aprueba o rechaza. Si al aprobar falta el consentimiento de la persona, el texto llega REDACTADO desde la
 * propuesta (que agente, para que, que permisos) y un solo "Aceptar y emitir" lo guarda y aprueba (parte c).
 *
 * Sin DOM: lo prueba scripts/check-llaves-propuestas.mjs.
 */

/** "la persona 23c960b1" / "el negocio biz_x" / "nadie (la propuesta no dice)". */
export function destinoDe(p) {
  if (p?.sujeto) return 'la persona ' + String(p.sujeto).slice(0, 8);
  if (p?.negocio) return 'el negocio ' + p.negocio;
  return 'nadie (la propuesta no dice)';
}

/** Los permisos en el idioma de la pantalla: el "que" del catalogo; si no esta, el id tal cual (no se esconde). */
export function permisosEnPalabras(ids, catalogo) {
  const porId = new Map((Array.isArray(catalogo) ? catalogo : []).map((s) => [s.id, s.que]));
  return (Array.isArray(ids) ? ids : []).map((id) => ({ id, que: porId.get(id) || id, conocido: porId.has(id) }));
}

/**
 * El consentimiento redactado desde la propuesta, para que Josse lo lea y acepte (o lo corrija) en vez de escribirlo.
 * Nombra el agente, el nombre de la llave, lo que se concede (en palabras) y el motivo de Ares.
 */
export function borradorDeConsentimiento(p, faltan, catalogo) {
  const que = permisosEnPalabras(faltan && faltan.length ? faltan : p?.permisos, catalogo).map((x) => x.que.replace(/[.;]\s*$/, ''));
  const quien = [p?.agente, p?.nombre ? '(' + p.nombre + ')' : ''].filter(Boolean).join(' ') || 'el asistente';
  const para = p?.motivo ? ' Para: ' + String(p.motivo).trim().replace(/\.?$/, '.') : '';
  return `Autorizo a ${quien} a: ${que.join('; ')}.${para}`;
}
